
import User from '@/classes/auth/User'
export default {
    name: 'AppNavbar',
    components: {},
    data: () => ({
        links: [
            {   
                name: 'main',
                label: 'Контакты',
                icon: 'fa-solid fa-book',
                exact: true
            },
            {   
                name: 'saved',
                label: 'Сохранённые сообщения',
                icon: 'fa-solid fa-save',
                callback: 'onSaveTap'
            },
            {   
                name: 'settings',
                label: 'Пользователь',
                icon: 'fa-solid fa-user',
                callback: 'profileEdit'
            },
            {   
                name: 'settings',
                label: 'Настройки',
                icon: 'fa-solid fa-gear',
                callback: 'configure'
            },
            {   
                name: 'logout',
                label: 'Выход',
                icon: 'fa-solid fa-right-from-bracket',
                callback: 'onLogoutTap'
            }
        ],
        showModalSearch: false,
        showModalLogout: false,
        search: ''
    }),
    methods: {
        logout(): void {
            this.$store.dispatch('auth/logout')
            this.$router.push({name: 'login', query: {
                message: "auth/session-closed"
            }})
        },
        onSaveTap(): void {
            this.$toast.show('Пока тут ничего нет')
        },
        onLogoutTap(): void {
            this.showModalLogout = true
        },
        profileEdit(): void {
            this.$router.push({name: 'profile-edit', params: {uid: this.user.uid}})
        },
        configure(): void {
            this.$toast.show('Пока тут ничего нет')
        },
        onClick(link): void {
            if(!link.callback) {
                this.$router.push({ name: link.name, })
            }
            else if( this[link.callback] ) this[link.callback]()
        }
    },
    computed: {
        user(): User {
            return this.$store.getters['auth/getUser']
        }
    },
    watch: {
        search: {
            async handler() {
                if(this.debouncedSearchQuery) this.debouncedSearchQuery.cancel()

            }   
        }
    }
}
